import { SansTitle } from '../SansTitle/SansTitle'
import type { CartTitleProps } from './CartTitle.types'

export const CartTitle = ({ title }: CartTitleProps): JSX.Element => {
  return (
    <SansTitle as="h2" size="sm" color="primary" fontWeight="600">
      {title}
    </SansTitle>
  )
}
